<template>
  <div
    :class="classes(
      n(),
      n(`--${theme}`),
      [rounded, n('--rounded')]
    )
    "
    :role="noticeBarRole"
    :aria-label="content"
    @click="onClickNoticeBar"
  >
    <!-- 左侧icon -->
    <div
      :class="classes(n('prefix-icon'))"
      aria-hidden="true"
    >
      <template v-if="$slots.prefixIcon">
        <slot name="prefixIcon" />
      </template>
      <component
        :is="prefixIconComp"
        v-else
        width="1em"
      />
    </div>
    <!-- 内容 -->
    <div :class="classes(n('content'))">
      {{ content }}
    </div>
    <!-- 右侧 -->
    <div
      v-if="operation || suffixIconComp"
      :class="classes(n('suffix'))"
    >
      <!-- 右侧操作按钮 -->
      <div
        v-if="operation"
        :class="classes(n('operation'))"
        role="button"
        :aria-label="operation"
        @click.stop="onClickOperation"
      >
        {{ operation }}
      </div>
      <!-- 右侧icon -->
      <div
        v-if="suffixIconComp"
        :class="classes(n('suffix-icon'), n(`suffix-icon--${suffixIcon}`))"
        role="button"
        :aria-label="suffixIconAriaLabel"
        @click="onClickSuffixIcon"
      >
        <component
          :is="suffixIconComp"
          width="1em"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { AnnouncementIcon, ErrorIcon, CloseIcon, ArrowRightIcon } from '@tencent/wphk-icon-vue';
import { createNamespace } from '../utils/components';
import { props } from './props';
import { emits } from './emits';

const { name, n, classes } = createNamespace('notice-bar');

export default defineComponent({
  name,
  props,
  emits,
  setup(props, { emit }) {
    const prefixIconComp = computed(() => {
      if (props.theme === 'danger') return ErrorIcon;
      return AnnouncementIcon;
    });
    const suffixIconComp = computed(() => {
      if (props.suffixIcon === 'close') return CloseIcon;
      if (props.suffixIcon === 'go') return ArrowRightIcon;
    });
    const noticeBarRole = computed(() => {
      if (props.theme === 'danger') return 'alert';
      return 'status';
    });
    const suffixIconAriaLabel = computed(() => {
      if (props.suffixIcon === 'close') return '关闭';
      if (props.suffixIcon === 'go') return '查看更多';
    });
    const onClickNoticeBar = () => {
      if (props.suffixIcon === 'go') {
        emit('more');
      }
    };
    const onClickOperation = () => {
      emit('operation');
    };
    const onClickSuffixIcon = () => {
      if (props.suffixIcon === 'close') {
        emit('close');
      }
    };
    return {
      classes,
      n,
      prefixIconComp,
      suffixIconComp,
      noticeBarRole,
      suffixIconAriaLabel,
      onClickOperation,
      onClickNoticeBar,
      onClickSuffixIcon,
    };
  },
});
</script>
